import {
  DECISION_FORBIDDEN,
  ENVIRONMENT_MISMATCH_IS_PROD,
  ENVIRONMENT_MISMATCH_IS_SANDBOX,
  FLOW_MISMATCH,
  NO_DECISION_FOUND,
  SingleDecisionQueryErrorReason,
  VERSION_MISMATCH,
} from "src/api/decisionHistoryV2/decisionHistoryQueries";
import { assertUnreachable } from "src/utils/typeUtils";

export const FLOW_DECISION_HISTORY_UNAUTHORIZED_MESSAGE =
  "You don't have access to decision history for this Decision Flow. A workspace admin can grant it.";

export const WORKSPACE_DECISION_HISTORY_UNAUTHORIZED_MESSAGE =
  "You don't have access to decision history in this workspace. A workspace admin can grant it.";

export const getHistoryEmptyStateWording = (
  reason: SingleDecisionQueryErrorReason | "emptyData",
): { headline: string; description: string } => {
  switch (reason) {
    case ENVIRONMENT_MISMATCH_IS_PROD:
      return {
        headline: "Environment mismatch",
        description: "The decision you searched for is a live decision",
      };
    case ENVIRONMENT_MISMATCH_IS_SANDBOX:
      return {
        headline: "Environment mismatch",
        description: "The decision you searched for is a sandbox decision",
      };
    case DECISION_FORBIDDEN:
      return {
        headline: "Decision access denied",
        description: "You don't have permission to view this decision",
      };
    case FLOW_MISMATCH:
    case VERSION_MISMATCH:
    case NO_DECISION_FOUND:
      return {
        headline: "No decision found",
        description: "Make sure your input is correct or search a different ID",
      };
    case "emptyData":
      return {
        headline: "No results found",
        description:
          "Try adjusting the search or filter to find what you are looking for",
      };
    default:
      return assertUnreachable(reason);
  }
};
